const s = {
  name: "House",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23,18V9h-6v9H23z M19,16v-5h2v5H19z"/>
		<path class="st0" d="M23,26v9h-6v-9H23z M19,28v5h2v-5H19z"/>
		<path class="st0" d="M17,21v2h6v-2H17z"/>
		<path class="st0" d="M27.4,7h8.4L40,23h-2v15h2v2H0v-2h2V23H0L4.2,7H8V3h6v2.7L20,0L27.4,7z M8,38h4v-9c0-1.1-0.9-2-2-2
			c-1.1,0-2,0.9-2,2V38z M12,25.5V23H4v15h2v-9c0-2.2,1.8-4,4-4C10.7,25,11.4,25.2,12,25.5z M14,38h12V8.4l-6-5.7l-6,5.7V38z M36,23
			h-8v15h8V23z M28,21h9.4L34.2,9H28V21z M12,9H5.8L2.6,21H12V9z M12,7V5h-2v2H12z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as House
};
